const { useLang } = require('@fegobull/webapi').use;
import { type IELang } from '@ark/utils';
export const lang: IELang['VALUES'][number] = useLang().lang;
